import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/historyOrange.svg'


const _hoisted_1 = { class: "flex w-full justify-end items-center" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "my-5" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-center text-xl font-semibold" }, "Arahkan device scanner ke barcode Voucher untuk melakukan Redeem Voucher Souvenir")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "historyOrange",
  class: "mr-3"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "font-semibold color-primary" }, "Lihat Riwayat Redeem", -1)
const _hoisted_7 = { class: "text-center mt-5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Kembali ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QrScanner = _resolveComponent("QrScanner")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: $setup.showDialog,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ($setup.showDialog = $event)),
    class: "dialog-voucher relative",
    modal: true,
    dismissableMask: true
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hideDialogRedeem()))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          ($setup.showDialog)
            ? (_openBlock(), _createBlock(_component_QrScanner, {
                key: 0,
                style: {"width":"100%"},
                onOnDetect: $setup.onDetectScanner
              }, null, 8, ["onOnDetect"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_4,
        _createVNode("div", {
          class: "flex justify-center cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openHistoryRedeemSouvenir()))
        }, [
          _hoisted_5,
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            class: "p-button-outlined-orange p-button-sm rounded-md lg:mr-3",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.hideDialogRedeem()))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}